<template>
  <div class="toast-wrapper">
    <div class="toast-header">
      <div class="toast-brand">
        <img src="@/assets/images/logo.png" alt="Logo" class="logo" />
        <div class="title-group">
          <div class="title">MPULS HNK</div>
          <div class="subtitle">REGISTAR UDRUGA</div>
        </div>
      </div>
    </div>
    <div class="toast-body">
      {{ toastMessage }}
    </div>
  </div>
</template>

<script>
import { toRef } from "vue";

export default {
  props: {
    message: String,
    closeToast: Function,
  },
  setup(props) {
    const toastMessage = toRef(props.message);

    const close = () => {
      if (typeof props.closeToast === "function") {
        props.closeToast();
      }
    };

    return {
      toastMessage,
      close,
    };
  },
  watch: {
    props(value) {
      console.log(value);
    },
  },
};
</script>

<style scoped>
.toast-wrapper {
  background: white;
  border-radius: 8px;
  width: 100%;
}

.toast-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.toast-brand {
  display: flex;
  align-items: center;
}

.logo {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}

.title-group {
  display: flex;
  flex-direction: column;
}

.title {
  font-weight: 600;
  font-size: 12px;
}

.subtitle {
  font-size: 10px;
  color: #666;
}

.toast-meta {
  display: flex;
  align-items: center;
  gap: 8px;
}

.time {
  font-size: 12px;
  color: #888;
}

.close-btn {
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  color: #555;
}

.toast-body {
  font-size: 12px;
  color: #222;
}
</style>
